import { Injectable } from '@angular/core';
import { AssetsFileApiService } from '@portal-core/general/services/assets-file-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetsFileService {
  constructor(private apiService: AssetsFileApiService) { }

  /**
   * Loads the file from the assets folder.
   * @param filePath The path to the file relative to the assets folder. For example, for a file located at `src/assets/data/file.json`, the `filePath` would be `data/file.json`.
   *  */
  getFile$<T>(filePath: string,): Observable<T> {
    return this.apiService.getFile$<T>(filePath);
  }

  /**
   * Loads the file from the assets folder and returns its content as a string value.
   * @param filePath The path to the file relative to the assets folder. For example, for a file located at `src/assets/data/file.json`, the `filePath` would be `data/file.json`.
   *  */
  getTextFile$(filePath: string): Observable<string> {
    return this.apiService.getTextFile$(filePath);
  }
}
